import { createApp } from 'vue'
import App from './App.vue'
import router from "@/router";
import store from "@/store";
import MetaInfo from "vue-meta-info";
import ElementPlus from 'element-plus'
import VueLazyLoad from 'vue-lazyload'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import '@/permission' // 权限控制
import 'element-plus/dist/index.css'
import '@/assets/icon/iconfont.css'
//createApp(App).use(router).use(store).use(ElementPlus).mount('#app')
const app = createApp(App).use(router).use(store).use(MetaInfo).use(ElementPlus)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.use(ElementPlus);
app.use(VueLazyLoad,{
    preLoad: 1.3,
    attempt: 2,
});
app.mount("#app");
